import { render, staticRenderFns } from "./OrganizeMaintenance.vue?vue&type=template&id=2dd89d4c"
import script from "./OrganizeMaintenance.js?vue&type=script&lang=js&external"
export * from "./OrganizeMaintenance.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports